import { render, staticRenderFns } from "./insline.vue?vue&type=template&id=c55b2dc2&scoped=true&"
import script from "./insline.vue?vue&type=script&lang=js&"
export * from "./insline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55b2dc2",
  null
  
)

export default component.exports